module.exports = __webpack_public_path__ + "static/media/file-icon-share.a2b5fa47.svg";